import { RegistryCategory } from '../RegistryCategory';
export class ActorFilterRegistryCategory extends RegistryCategory {
    get categories() {
        return super.categories;
    }
    get leafs() {
        return super.leafs;
    }
    get allLeafs() {
        return super.allLeafs;
    }
}
